import * as React from 'react';
import { styled, alpha } from '@mui/material/styles';

import Menu, { MenuProps } from '@mui/material/Menu';
import MenuItem from '@mui/material/MenuItem';
import Divider from '@mui/material/Divider';
import Box from '@mui/material/Box';
import Typography from '@mui/material/Typography';

import { useTranslation } from 'react-i18next';

const languages = [
    { code: 'uz', label: "O'zbek", flag: 'uzFlag.png' },
    { code: 'ru', label: 'Русский', flag: 'ruFlag.png' },
    { code: 'en', label: 'English', flag: 'enFlag.png' },
    { code: 'tr', label: 'Türkçe', flag: 'trFlag.png' },
    { code: 'zh', label: '中國', flag: 'zhFlag.png' }
];

interface LangMenuProps {
    open: boolean;
    onClose: (lang?: string) => void;
    anchorEl: HTMLElement | null;
}

export default function LangMenu({ open, onClose, anchorEl }: LangMenuProps) {
    const { i18n } = useTranslation();

    return (
        <StyledMenu
            id="lang-menu"
            MenuListProps={{
                'aria-labelledby': 'lang-menu-button'
            }}
            anchorEl={anchorEl}
            open={open}
            onClose={() => onClose()}
        >
            {languages.map(({ code, label, flag }, index) => (
                <React.Fragment key={code}>
                    <MenuItem onClick={() => onClose(code)} disableRipple>
                        <Box component="img" src={require(`../assests/icons/${flag}`)} sx={{ width: 22, height: 16 }} />
                        <Typography
                            variant="h5"
                            component="h2"
                            sx={{
                                fontSize: 16,
                                fontWeight: 600,
                                ml: 1,
                                width: 100,
                                mr: 1.5,
                                color: i18n.language === code ? '#9A9FA5' : (theme) => theme.palette.text.primary
                            }}
                        >
                            {label}
                        </Typography>
                        <Box
                            component="img"
                            src={require('../assests/icons/tick.png')}
                            sx={{
                                display: i18n.language === code ? 'flex' : 'none',
                                width: 24,
                                height: 20
                            }}
                        />
                    </MenuItem>
                    {index < languages.length - 1 && <Divider sx={{ my: 0.5 }} />}
                </React.Fragment>
            ))}
        </StyledMenu>
    );
}
const StyledMenu = styled((props: MenuProps) => (
    <Menu
        elevation={0}
        anchorOrigin={{
            vertical: 'bottom',
            horizontal: 'right'
        }}
        transformOrigin={{
            vertical: 'top',
            horizontal: 'right'
        }}
        {...props}
    />
))(({ theme }) => ({
    '& .MuiPaper-root': {
        borderRadius: 15,
        marginTop: theme.spacing(1),
        minWidth: 180,
        fontWeight: '700',
        fontSize: 16,
        padding: 5,
        color: theme.palette.mode === 'light' ? '#1A1D1F' : theme.palette.grey[300],
        boxShadow: 'rgb(255, 255, 255) 0px 0px 0px 0px, rgba(0, 0, 0, 0.05) 0px 0px 0px 1px, rgba(0, 0, 0, 0.1) 0px 10px 15px -3px, rgba(0, 0, 0, 0.05) 0px 4px 6px -2px',
        '& .MuiMenu-list': {
            padding: '4px 0'
        },
        '& .MuiMenuItem-root': {
            '& .MuiSvgIcon-root': {
                fontSize: 18,
                color: '#1A1D1F',
                marginRight: theme.spacing(1.5)
            },
            '&:active': {
                backgroundColor: alpha(theme.palette.primary.main, theme.palette.action.selectedOpacity)
            }
        }
    }
}));
